import classnames from 'classnames'
import React, { FC } from 'react'

import { ProductCardLink, ProductCardLinkProps } from '../product-card-actions/product-card-link'
import { useProductCardHover } from '../product-card-context/product-card-hover.context'

import { ProductPrice } from './product-price'
import styles from './product-title-section.module.scss'

export type ProductTitleSectionProps = {
  brandName?: string
  titleClassName?: string
  productPrefixPriceClassName?: string
  priceClassName?: string
  hideProductName?: boolean
  productPriceClass?: string
  productPriceWrapperClass?: string
  nameAndPriceSectionClass?: string
} & ProductCardLinkProps

export const ProductTitleSection: FC<ProductTitleSectionProps> = props => {
  const {
    title,
    brandName,
    shopifyId,
    selectedCardVariant,
    reviewSummary,
    productClickTrackConfig,
    slug,
    additionalAttributes,
    selectorKey,
    tracker,
    siteSearchQuery,
    productPosition,
    productSearchObjectId,
    colorVariants,
    hideProductName,
    titleClassName,
    productPriceWrapperClass,
    nameAndPriceSectionClass,
    productCardLinkClass,
    eddDetails,
  } = props

  const { setHovered } = useProductCardHover()

  return (
    <div
      className={classnames(styles.container, productPriceWrapperClass)}
      onMouseEnter={() => {
        setHovered(true)
      }}
      onMouseLeave={() => {
        setHovered(false)
      }}
    >
      <div
        className={classnames(styles.nameAndPriceSection, nameAndPriceSectionClass, hideProductName && styles.hideName)}
      >
        <div>
          <h3 className={classnames(titleClassName)}>
            <ProductCardLink
              slug={slug}
              additionalAttributes={additionalAttributes}
              selectorKey={selectorKey}
              tracker={tracker}
              productCardLinkClass={productCardLinkClass}
              selectedCardVariant={selectedCardVariant}
              siteSearchQuery={siteSearchQuery}
              productPosition={productPosition}
              productSearchObjectId={productSearchObjectId}
              title={title}
              shopifyId={shopifyId}
              reviewSummary={reviewSummary}
              productClickTrackConfig={productClickTrackConfig}
              colorVariants={colorVariants}
              eddDetails={eddDetails}
              product={props.product}
              onClickCb={props.onClickCb}
            >
              {selectedCardVariant?.displayConfig.displayName && (
                <span className="sr-only">{selectedCardVariant.displayConfig.displayName}&nbsp;</span>
              )}
              {!hideProductName && title}
            </ProductCardLink>
          </h3>
        </div>
        <ProductPrice {...props} />
      </div>
      {brandName && <div className={styles.brandNameSection}>{brandName}</div>}
    </div>
  )
}
